exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body-main[data-v-37cb00bc]{position:relative}.modal-body-main .product-size[data-v-37cb00bc]{padding:0 0 10px 0;font-size:12px;font-weight:700}.modal-body-main .size-tips[data-v-37cb00bc]{padding-top:10px;font-size:12px;color:#999;font-weight:700}.modal-body-main .size-tips .notice-tips[data-v-37cb00bc]{color:#f30}", ""]);

// exports
